import { Text } from './text/Text';

export const FieldValues = {
  Text
};
